define('apps/admin/views/block-message',[
        'njs!apps/admin/templates/includes/_block_message(params:tmpl=admin/main/includes/_block_message.html)',
    ], function(template) {
        'use strict';

        return Mn.ItemView.extend({

            "template": template,

            "tagName": "div",

            "className": function() {
                var messageType = this.model.get('message_type');
                return "comet-block-message comet-block-message--" + messageType;
            },

            "attributes": function() {
                if (this.model.get('message_type') === 'error') {
                    return {
                        'role': 'alert'
                    };
                };
            }

        });
});

